export const formatDistance = (value: number): string =>
  `${(value / 1000).toLocaleString('pl-PL', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  })} km`;
